import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const SchM1Form1065 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Schedule M-1 (Form 1065): Reconciliation of Income"
          description="Complete IRS Schedule M-1 (Form 1065) to reconcile partnership book income with tax return income. Line-by-line guide, exemptions and e-filing tips"
          keywords=""
          canonical="resources/business-tax/schedule-m-1-form-1065/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          Form 1065{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule M-1:</span>
          </span>{' '}
          Reconciliation of Income (Loss) per Books With Income (Loss) per
          Return
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-m-1-form-1065/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule M-1 (Form 1065) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule M-1 (Form 1065)
                        </strong>{' '}
                        and how partnerships use it to reconcile differences
                        between book income reported in financial records and
                        taxable income reported on the partnership tax return.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how Schedule M-1 works with Form 1065
                        </strong>{' '}
                        by understanding each reconciliation line, including
                        income adjustments, deductible expenses, non-deductible
                        items, and other book-to-tax differences.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the difference between book income and tax
                          income,
                        </strong>{' '}
                        including temporary and permanent differences such as
                        depreciation adjustments, meals and entertainment
                        limitations, tax-exempt income, and timing differences.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Every partnership that prepares financial statements also
                      keeps a set of internal accounting records — commonly
                      referred to as "books." However, the way income and
                      expenses are recorded in those books does not always match
                      the way they are treated under the Internal Revenue Code.
                      Tax rules apply specific limitations, timing requirements,
                      and special treatments that can cause the taxable income
                      on a partnership's return to differ — sometimes
                      significantly — from the net income shown in its
                      accounting records.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      <span style={{ fontWeight: 600 }}> Schedule M-1</span> is
                      the section of{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1065-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1065
                      </Link>{' '}
                      that bridges this gap. Its full name is{' '}
                      <span style={{ fontStyle: 'italic' }}>
                        Reconciliation of Income (Loss) per Books With Analysis
                        of Net Income (Loss) per Return,
                      </span>{' '}
                      and its purpose is straightforward: to explain, line by
                      line, why book income and taxable income are different.
                      When correctly completed, Schedule M-1 gives the IRS — and
                      the partnership's own tax team — a clear, transparent
                      picture of every adjustment made between the two figures.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      This guide covers everything partnerships, partners, and
                      tax professionals need to know about Schedule M-1 — from
                      who must file it, to a line-by-line breakdown, to the most
                      common book-to-tax differences, and how it connects to the
                      rest of{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1065-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1065
                      </Link>
                      .
                    </Typography>
                  </Box>
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule M-1?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whois" sx={{ color: '#0202ff' }}>
                          Who Is Required to File Schedule M-1?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#schm1" sx={{ color: '#0202ff' }}>
                          Schedule M-1 vs. Schedule M-3: What's the Difference?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#under" sx={{ color: '#0202ff' }}>
                          Understanding Book Income vs. Tax Income
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#line" sx={{ color: '#0202ff' }}>
                          Schedule M-1 Line-by-Line Breakdown
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Book-to-Tax Differences at a Glance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#howsch" sx={{ color: '#0202ff' }}>
                          How Schedule M-1 Connects to the Rest of Form 1065
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#audit" sx={{ color: '#0202ff' }}>
                          Schedule M-1 and the IRS Audit Perspective
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#capital" sx={{ color: '#0202ff' }}>
                          Schedule M-1 and the Capital Account Reporting
                          Requirement
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#error" sx={{ color: '#0202ff' }}>
                          Common Errors to Avoid on Schedule M-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faq" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key IRS Resources for Schedule M-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#related" sx={{ color: '#0202ff' }}>
                          Related TaxZerone Resources
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule M-1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M-1 is a one-page reconciliation schedule that
                  appears near the end of{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065
                  </Link>
                  . It works as follows:
                </Typography>

                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 1</span> starts with
                    net income (or loss) as recorded on the partnership's books
                    — essentially the bottom line from the partnership's income
                    statement.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Lines 2 through 7</span>{' '}
                    add back or subtract items that explain the difference
                    between book income and tax income.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Line 9</span> arrives at
                    the income (or loss) per the tax return — the figure that
                    must match Line 1 of the Analysis of Net Income (Loss) on
                    Form 1065, page 5.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Think of Schedule M-1 as a formal bridge: it starts on one
                  side (book income) and arrives on the other side (taxable
                  income), with each line representing a specific crossing point
                  where the two systems diverge.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whois"
                >
                  Who Is Required to File Schedule M-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Not every partnership must complete Schedule M-1. According to
                  the{' '}
                  <Link
                    href="https://www.irs.gov/instructions/i1065"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    IRS Instructions for Form 1065
                  </Link>{' '}
                  , a partnership is{' '}
                  <span style={{ fontWeight: 600 }}> exempt</span> from
                  completing Schedules L, M-1, and{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-2/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    M-2
                  </Link>{' '}
                  only if it satisfies{' '}
                  <span style={{ fontWeight: 600 }}>all four</span> of the
                  following conditions, as answered on{' '}
                  <Link
                    href="/resources/business-tax/schedule-b/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule B
                  </Link>
                  , Line 4:
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Exemption Condition
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Threshold
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Total receipts for the tax year
                          </TableCell>

                          <TableCell>
                            {' '}
                            Less than{' '}
                            <span style={{ fontWeight: 600 }}> $250,000</span>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Total assets at end of tax year
                          </TableCell>

                          <TableCell>
                            {' '}
                            Less than{' '}
                            <span style={{ fontWeight: 600 }}>$1 million</span>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Schedule K-1s filed with return and furnished to
                            partners
                          </TableCell>

                          <TableCell>
                            {' '}
                            On or before the due date (including
                            extensions){' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Not filing or required to file Schedule M-3
                          </TableCell>

                          <TableCell> N/A </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the partnership{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    fails to meet even one
                  </span>{' '}
                  of these four requirements, it must complete Schedule M-1.
                  This means partnerships that grow beyond the $250,000 receipts
                  or $1 million asset threshold in any given year must begin
                  filing Schedule M-1 for that year and all future years until
                  they qualify for the exemption again.
                </Typography>

                <Typography
                  component="div"
                  variant="body1"
                  sx={{
                    mb: 2,
                    borderLeft: '4px solid #640378',
                    borderRadius: 3,
                    backgroundColor: '#f7e1ff',
                    p: 2,
                  }}
                >
                  <span style={{ fontWeight: 600 }}> Important:</span> A
                  partnership that voluntarily files Schedule M-3 (required for
                  partnerships with $10 million or more in total assets) is not
                  required to also complete Schedule M-1 for those items covered
                  by Schedule M-3. However, if only a portion of the return is
                  governed by Schedule M-3, Schedule M-1 may still be required
                  for the remaining items.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="schm1"
                >
                  Schedule M-1 vs. Schedule M-3: What's the Difference?
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Larger partnerships are subject to a more expansive
                  reconciliation requirement.{' '}
                  <span style={{ fontWeight: 600 }}> Schedule M-3</span> (Net
                  Income (Loss) Reconciliation for Certain Partnerships) is
                  required when a partnership's total assets equal or exceed{' '}
                  <span style={{ fontWeight: 600 }}> $10 million </span> at
                  year-end. Schedule M-3 provides a far more granular breakdown
                  of book-to-tax differences than Schedule M-1 and requires the
                  partnership to reconcile to consolidated financial statements
                  where applicable.
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Feature
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Schedule M-1
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Schedule M-3
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>Who files</TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Partnerships with $1M+ assets or $250K+ receipts
                            (that don't file M-3)
                          </TableCell>

                          <TableCell>
                            {' '}
                            Partnerships with $10M+ in total assets
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Detail level{' '}
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Summary (9 lines)
                          </TableCell>

                          <TableCell> Highly detailed (multi-page)</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Financial statement basis
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>
                            Internal books
                          </TableCell>

                          <TableCell>
                            {' '}
                            Consolidated or audited financials{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontSize: 15 }}>
                            Required with
                          </TableCell>
                          <TableCell sx={{ fontSize: 15 }}>Form 1065</TableCell>

                          <TableCell> Form 1065</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If your partnership is required to file Schedule M-3, it uses
                  that form instead of Schedule M-1 to fulfill the
                  reconciliation requirement for items covered by M-3. For those
                  items, Schedule M-1 lines are generally left blank. For more
                  context,{' '}
                  <Link
                    href="/resources/business-tax/schedule-m-2/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule M-2
                  </Link>{' '}
                  — the Analysis of Partners' Capital Accounts — works alongside
                  Schedule M-1 and must also reconcile consistently with it.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="under"
                >
                  Understanding Book Income vs. Tax Income
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before diving into the line-by-line breakdown, it helps to
                  understand the two fundamental accounting systems that
                  Schedule M-1 reconciles.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Book Income (GAAP or Internal Accounting Records):
                  </span>{' '}
                  Book income is the net profit or loss a partnership reports in
                  its internal financial records. These records typically follow
                  Generally Accepted Accounting Principles (GAAP) or a similar
                  internal accounting method. Book income governs how the
                  partnership presents its financial results to partners,
                  lenders, and investors. There are no IRS limitations on what a
                  partnership records in its books.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> Tax Income:</span> Tax
                  income — also called income per return — is calculated
                  according to the Internal Revenue Code. Tax rules impose
                  limits on certain deductions, require specific timing for
                  income recognition, and create permanent and temporary
                  differences from book accounting. The partnership's tax income
                  is what flows through to partners via{' '}
                  <Link
                    href="/resources/business-tax/schedule-k1-1065/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule K-1
                  </Link>{' '}
                  and ultimately affects each partner's individual tax return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Types of Book-to-Tax Differences:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  There are two broad categories of book-to-tax differences that
                  appear on Schedule M-1:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Permanent Differences —
                  </span>{' '}
                  Items that are recognized differently under GAAP and the tax
                  code on a permanent basis, with no future reversal. Examples
                  include:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Meals and entertainment expenses (only 50% deductible for
                    tax; 100% for books)
                  </li>
                  <li>
                    Tax-exempt income (included in books; excluded from taxable
                    income)
                  </li>
                  <li>Non-deductible fines and penalties</li>
                  <li>
                    Life insurance premiums on key partners (non-deductible for
                    tax)
                  </li>
                </Box>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Temporary Differences —
                  </span>{' '}
                  Items where the timing of recognition differs between books
                  and tax, but the total recognized over time is the same.
                  Examples include:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Depreciation differences (accelerated or bonus depreciation
                    for tax vs. straight-line for books)
                  </li>
                  <li>
                    Deferred revenue (recognized when earned for books;
                    sometimes recognized earlier for tax)
                  </li>
                  <li>
                    Prepaid expenses (expensed immediately for tax; amortized
                    for books)
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="line"
                >
                  Schedule M-1 Line-by-Line Breakdown
                </Typography>

                <picture>
                  <source srcSet="/assets/images/f1065-schm1-img.webp" />
                  <source srcSet="/assets/images/f1065-schm1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/f1065-schm1-img.png"
                    loading="lazy"
                    alt="Form 1065 Schedule M-1 showing the reconciliation of book income (loss) to tax return income."
                    width={760}
                    height={228}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Here is a detailed explanation of each line on Schedule M-1
                  for{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065
                  </Link>
                  :
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 1 — Net Income (Loss) per Books
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  This is the starting point of Schedule M-1 and represents the
                  partnership's net income or loss as it appears in the
                  partnership's accounting records (books) — not the tax return.
                  This amount is taken directly from the partnership's income
                  statement or profit and loss statement for the year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If the partnership's books and tax return report the same
                  income with no adjustments, then Lines 2 through 7 would all
                  be zero and Line 9 would equal Line 1. In practice, however,
                  most partnerships with any meaningful activity will have at
                  least some adjustments.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 2 — Income Included on Schedule K, Lines 1, 2, 3c, 5, 6a,
                  7, 8, 9a, 10, and 11, Not Recorded on Books This Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This line captures{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    income that the tax return recognizes but the books do not
                  </span>{' '}
                  — at least not in the same tax year. These are situations
                  where tax rules require income to be reported on the return
                  earlier than the partnership would record it on its books.
                </Typography>
                <Typography variant="body1">
                  Common examples include:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Advance payments and prepaid income:
                    </span>{' '}
                    The IRS may require certain advance payments to be included
                    in taxable income in the year received, even if the
                    partnership's books defer recognition until the service or
                    goods are delivered.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Mark-to-market adjustments:
                    </span>{' '}
                    Partnerships in securities or commodities trading may be
                    required to recognize unrealized gains under Section 475(f)
                    that are not yet reflected in book income.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Installment sale income:
                    </span>{' '}
                    Where the partnership uses the installment method for books
                    but recognizes the full gain in the current year for tax
                    purposes.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 3 — Guaranteed Payments
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> Guaranteed payments</span>{' '}
                  are amounts paid to a partner for services rendered or for the
                  use of capital, regardless of whether the partnership earned a
                  profit. They are treated as deductible business expenses on
                  the partnership's tax return under Section 707(c), but they
                  reduce taxable income (and therefore reduce the income per
                  return figure).
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  On Schedule M-1, guaranteed payments are added back on Line 3
                  because they are already deducted in arriving at net income
                  per the tax return but need to be reconciled against book
                  treatment, where they may be recorded differently or in a
                  different period.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  For reference, guaranteed payments are reported on{' '}
                  <Link
                    href="/resources/business-tax/schedule-k/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule K
                  </Link>
                  , Line 4, and flow through to each partner's{' '}
                  <Link
                    href="/resources/business-tax/schedule-k1-1065/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule K-1
                  </Link>
                  , Box 4.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 4 — Expenses Recorded on Books This Year Not Included on
                  Schedule K
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This line reports{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    book expenses that are not deductible on the tax return —
                  </span>{' '}
                  either because they are permanently disallowed under the tax
                  code or because they will be deducted in a future year
                  (temporary differences).
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Line 4 is typically broken into two sub-lines:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 4a — Depreciation:
                  </span>{' '}
                  <br />
                  This is one of the most common book-to-tax differences for
                  partnerships with significant fixed assets. The tax return
                  often uses accelerated depreciation methods — such as the
                  Modified Accelerated Cost Recovery System (MACRS), bonus
                  depreciation (Section 168(k)), or the Section 179 immediate
                  expensing election — which front-load larger deductions in the
                  early years of an asset's life. In contrast, the partnership's
                  books may use straight-line depreciation spread evenly over
                  the asset's useful life.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  When{' '}
                  <span style={{ fontWeight: 600 }}>
                    book depreciation exceeds tax depreciation,
                  </span>{' '}
                  the difference is entered on Line 4a. When{' '}
                  <span style={{ fontWeight: 600 }}>
                    tax depreciation exceeds book depreciation
                  </span>{' '}
                  (which is common with bonus depreciation), the difference
                  appears on Line 6 instead (as a tax deduction not yet recorded
                  on books).
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  For more detail on how depreciation deductions flow through
                  the return, see{' '}
                  <Link
                    href="/resources/business-tax/form-4562/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 4562
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 4b — Travel and Entertainment:
                  </span>{' '}
                  <br />
                  The IRS limits the deductibility of meal expenses to{' '}
                  <span style={{ fontWeight: 600 }}> 50%</span> of the actual
                  cost (or 80% for certain transportation workers). Some
                  entertainment expenses are entirely nondeductible. The
                  partnership's books, however, may record the full 100% of
                  these costs as an expense.
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  The non-deductible portion — the amount recorded on books but
                  disallowed on the return — is entered on Line 4b. This is a
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    permanent difference:
                  </span>{' '}
                  the disallowed amount will never be deducted on any future
                  return.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 5 — Other Expenses Recorded on Books This Year Not
                  Included on Schedule K
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This catchall line captures additional book expenses that are
                  not deductible on the current-year tax return and are not
                  covered by the specific categories in Lines 4a or 4b. A
                  separate statement must be attached listing each item.
                </Typography>
                <Typography variant="body1">
                  Common examples include:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Federal income taxes:
                    </span>{' '}
                    While partnerships are pass-through entities and generally
                    do not pay federal income taxes at the entity level, certain
                    state-level entity taxes recorded on the books may not be
                    deductible for federal tax purposes.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Non-deductible fines and penalties:
                    </span>{' '}
                    Fines paid to a government for violating a law are
                    specifically disallowed under Section 162(f).
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Excess charitable contributions:
                    </span>{' '}
                    Contributions that exceed the applicable percentage
                    limitation.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Life insurance premiums:
                    </span>{' '}
                    Premiums paid on key-person life insurance where the
                    partnership is the beneficiary are not deductible.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Accrued expenses not yet deductible:
                    </span>{' '}
                    Under the economic performance rules of Section 461(h),
                    certain accrued liabilities may be recorded on the books but
                    cannot be deducted until economic performance has occurred.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Capitalized costs:</span>{' '}
                    Some costs that are expensed on the books must be
                    capitalized and amortized over time for tax purposes (e.g.,
                    certain startup or organizational costs under Sections 195
                    and 709).
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 6 — Income Recorded on Books This Year Not Included on
                  Schedule K
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This line captures the{' '}
                  <span style={{ fontWeight: 600 }}> reverse</span> of Line 2 —
                  income the books have recorded in the current year that is{' '}
                  <span style={{ fontWeight: 600 }}>
                    not included on the tax return
                  </span>{' '}
                  for this year.
                </Typography>
                <Typography variant="body1">
                  Common examples include:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Tax-exempt income:</span>{' '}
                    Interest income from state and municipal bonds is included
                    in book income but is excluded from federal taxable income.
                    This is a permanent difference. It is also reported on
                    Schedule K, Line 18a.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Deferred gain recognition:{' '}
                    </span>{' '}
                    In some cases, gain recognized on the books may be deferred
                    for tax purposes (e.g., installment sales where the book and
                    tax treatment differ in timing).
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Life insurance proceeds:{' '}
                    </span>{' '}
                    Proceeds received on a key-person life insurance policy are
                    included in book income but excluded from federal taxable
                    income.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 7 — Deductions on Schedule K Not Charged Against Book
                  Income This Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This line captures{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    deductions taken on the tax return that have not yet been
                    recorded as expenses in the partnership's books.
                  </span>{' '}
                  These are typically temporary differences that will reverse in
                  future years.
                </Typography>
                <Typography variant="body1">
                  Common examples include:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Bonus depreciation and Section 179 expensing:
                    </span>{' '}
                    These accelerated tax deductions may far exceed the book
                    depreciation for the same assets, resulting in a tax
                    deduction that has no corresponding book entry in the
                    current year.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Prepaid expenses deducted for tax:
                    </span>{' '}
                    Under the 12-month rule, certain prepaid expenses paid for
                    services or benefits extending no more than 12 months beyond
                    the payment date may be deducted immediately for tax
                    purposes but amortized on the books.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Depletion allowances:
                    </span>{' '}
                    Oil, gas, and mineral partnerships may claim percentage
                    depletion for tax purposes that exceeds cost depletion
                    recorded on the books.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 8 — Add Lines 6 and 7
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This is a simple arithmetic subtotal — the sum of Lines 6 and
                  7, representing the total of income not taxed plus deductions
                  not yet charged to books.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Line 9 — Income (Loss) per Return
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 9 is the final reconciled figure —
                  </span>{' '}
                  the partnership's income or loss as reported on the tax
                  return. This amount must equal Line 1 of the Analysis of Net
                  Income (Loss) on Form 1065, page 5.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The formula is:{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <span style={{ fontWeight: 600 }}> Line 1</span> (Net income
                  per books){' '}
                  <span style={{ fontWeight: 600 }}>+ Lines 2, 3, 4, 5</span>{' '}
                  (Add: items that increase taxable income vs. books){' '}
                  <span style={{ fontWeight: 600 }}>− Line 8</span> (Subtract:
                  items that decrease taxable income vs. books){' '}
                  <span style={{ fontWeight: 600 }}>= Line 9</span> (Income per
                  return)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  If Line 9 does not reconcile to the Analysis of Net Income
                  (Loss), there is an error somewhere in the return that must be
                  found and corrected before filing.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Book-to-Tax Differences at a Glance
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Item
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Book Treatment
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Tax Treatment
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Where on M-1
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Straight-line depreciation (books) vs. bonus
                            depreciation (tax)
                          </TableCell>
                          <TableCell>Smaller deduction </TableCell>
                          <TableCell>Larger deduction </TableCell>
                          <TableCell>Line 7 </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Accelerated depreciation (books) vs. straight-line
                            (tax)
                          </TableCell>
                          <TableCell>Larger deduction </TableCell>
                          <TableCell>Smaller deduction </TableCell>
                          <TableCell>Line 4a </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Meals and entertainment (50% limit)
                          </TableCell>
                          <TableCell>100% expensed</TableCell>
                          <TableCell>50% deductible</TableCell>
                          <TableCell>Line 4b</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Municipal bond interest</TableCell>
                          <TableCell>Recorded as income </TableCell>
                          <TableCell>Tax-exempt </TableCell>
                          <TableCell>Line 6 </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Fines and penalties</TableCell>
                          <TableCell>Expensed on books </TableCell>
                          <TableCell>Non-deductible </TableCell>
                          <TableCell>Line 5</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Life insurance proceeds received{' '}
                          </TableCell>
                          <TableCell>Recorded as income </TableCell>
                          <TableCell>Tax-exempt </TableCell>
                          <TableCell>Line 6 </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Life insurance premiums paid </TableCell>
                          <TableCell>Expensed on books </TableCell>
                          <TableCell>Non-deductible </TableCell>
                          <TableCell>Line 5</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Prepaid expenses (12-month rule){' '}
                          </TableCell>
                          <TableCell>Amortized on books </TableCell>
                          <TableCell>Deducted immediately for tax </TableCell>
                          <TableCell>Line 7 </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Deferred revenue (advance payments){' '}
                          </TableCell>
                          <TableCell>Deferred on books </TableCell>
                          <TableCell>Taxable when received </TableCell>
                          <TableCell>Line 2</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Section 179 expensing </TableCell>
                          <TableCell>Not on books </TableCell>
                          <TableCell>Immediate tax deduction </TableCell>
                          <TableCell>Line 7 </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="howsch"
                >
                  How Schedule M-1 Connects to the Rest of Form 1065
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule M-1 does not stand alone — it is tightly linked to
                  several other schedules and forms within the{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1065
                  </Link>{' '}
                  package:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    <Link
                      href="/resources/business-tax/schedule-l/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule L
                    </Link>{' '}
                    (Balance Sheet per Books):
                  </span>{' '}
                  The beginning and ending balance sheet figures in Schedule L
                  must be consistent with the income reconciliation shown in
                  Schedule M-1. Changes in asset values (particularly
                  depreciation) and partner equity should be consistent across
                  both schedules.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    <Link
                      href="/resources/business-tax/schedule-m-2/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule M-2
                    </Link>{' '}
                    (Analysis of Partners' Capital Accounts):
                  </span>{' '}
                  The net income (loss) entered in Schedule M-2, Line 3 must
                  equal the book net income (loss) from Schedule M-1, Line 1 —
                  not the tax income on Line 9. This is a critical and
                  frequently misunderstood linkage. Schedule M-2 tracks changes
                  in partners' capital accounts on a book basis, not a tax
                  basis.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    <Link
                      href="/resources/business-tax/schedule-k/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Schedule K
                    </Link>{' '}
                    (Partners' Distributive Share Items):
                  </span>{' '}
                  The total income and deduction items reported on Schedule K
                  must be consistent with the tax income figure on Schedule M-1,
                  Line 9. Together, they represent the same taxable income of
                  the partnership — one in total (Schedule K) and one as a
                  reconciled figure (M-1, Line 9).
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    <Link
                      href="/resources/business-tax/form-4562/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 4562
                    </Link>{' '}
                    (Depreciation and Amortization):
                  </span>{' '}
                  Depreciation differences are one of the most common drivers of
                  Schedule M-1 adjustments. The depreciation amounts computed on
                  Form 4562 flow to Schedule M-1 as the "tax" side of the
                  depreciation comparison.
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    <Link
                      href="/resources/business-tax/form-4797/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 4797
                    </Link>{' '}
                    (Sales of Business Property):
                  </span>{' '}
                  Gains and losses on property sales may be recognized
                  differently for book and tax purposes, particularly for
                  installment sales or like-kind exchanges, requiring M-1
                  adjustments.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="audit"
                >
                  Schedule M-1 and the IRS Audit Perspective
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The IRS uses Schedule M-1 as an analytical tool when reviewing
                  partnership returns. Large or unusual M-1 adjustments —
                  particularly unexplained items on Lines 5 and 7 — can draw
                  scrutiny because they indicate that significant book income is
                  not being reported as taxable income. Examiners routinely
                  compare M-1 Line 1 (book income) to the return's taxable
                  income to assess whether the reconciliation is reasonable
                  given the nature and size of the partnership's business.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Partnerships should be prepared to provide:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    The underlying financial statements supporting Line 1 book
                    income
                  </li>
                  <li>Documentation for each item on Lines 2 through 7 </li>
                  <li>
                    Workpapers reconciling depreciation between books and tax
                  </li>
                  <li>
                    Supporting schedules for any "other" items claimed on Lines
                    5 and 7
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Accurate, well-documented Schedule M-1 workpapers are one of
                  the most effective tools a partnership can maintain to
                  demonstrate compliance and reduce audit exposure.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="capital"
                >
                  Schedule M-1 and the Capital Account Reporting Requirement
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Starting with the 2020 tax year, the IRS required all
                  partnerships to report partners' capital accounts on a{' '}
                  <span style={{ fontWeight: 600 }}> tax basis</span> in
                  Schedule M-2 and on the partner's{' '}
                  <Link
                    href="/resources/business-tax/schedule-k1-1065/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule K-1
                  </Link>
                  , Part II. This change has heightened the importance of
                  clearly distinguishing book income (used in Schedule M-2, Line
                  3) from tax income (used in Schedule K and Schedule M-1, Line
                  9).
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Partnerships that previously maintained capital accounts on a
                  GAAP or Section 704(b) basis were required to compute and
                  disclose the tax basis equivalent going forward. The M-1
                  reconciliation plays a central role in this process, as it
                  defines the tax income figure that drives tax-basis capital
                  account adjustments.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="error"
                >
                  Common Errors to Avoid on Schedule M-1
                </Typography>
                <Box component="ol" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Using tax income instead of book income on Line 1.
                    </span>{' '}
                    Line 1 must reflect the income per the partnership's books —
                    not the tax return. Using the wrong figure makes the entire
                    reconciliation incorrect.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Omitting items on Lines 5 or 7 without a supporting
                      statement.
                    </span>{' '}
                    The IRS expects a detailed breakdown of any "other" items.
                    Vague or missing statements for these lines are a common
                    deficiency in audits.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Failure to reconcile Line 9 to the Analysis of Net Income
                      (Loss).{' '}
                    </span>{' '}
                    If these two figures don't match, there is a mathematical or
                    categorization error that must be resolved. Filing a return
                    with a reconciliation that doesn't tie is a red flag.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Confusing book depreciation with tax depreciation.
                    </span>{' '}
                    Partnerships with significant fixed assets must carefully
                    track both sets of depreciation figures. Using the wrong
                    number on Lines 4a or 7 will cause both Schedule M-1 and{' '}
                    <Link
                      href="/resources/business-tax/schedule-l/"
                      sx={{ color: '#0202ff' }}
                    >
                      Schedule L
                    </Link>{' '}
                    to be incorrect.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Misclassifying permanent vs. temporary differences.
                    </span>{' '}
                    Permanent differences (like disallowed meals) and temporary
                    differences (like timing differences in depreciation)
                    require different treatment in long-term basis tracking and
                    deferred tax analysis.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Forgetting that Schedule M-2 ties to book income (Line 1),
                      not tax income (Line 9).
                    </span>{' '}
                    This is one of the most common errors on partnership returns
                    and is a frequent trigger for IRS correspondence.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faq"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Does every partnership have to file Schedule M-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Partnerships that meet all four conditions on{' '}
                  <Link
                    href="/resources/business-tax/schedule-b/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule B
                  </Link>{' '}
                  Line 4 — receipts under $250,000, assets under $1 million,
                  timely K-1 distribution, and no Schedule M-3 requirement — are
                  exempt from Schedule M-1.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. What if our partnership's book income and tax income are
                  identical?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You still need to complete Schedule M-1 if your partnership is
                  required to file it. Simply enter book income on Line 1 and
                  leave Lines 2 through 7 blank. Line 9 will equal Line 1,
                  confirming there are no differences.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. What does it mean when Schedule M-1 doesn't balance?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  A Schedule M-1 that doesn't reconcile — meaning Line 9 does
                  not equal Line 1 of the Analysis of Net Income (Loss) —
                  indicates an error in the return. This must be corrected
                  before filing. Common causes include misclassified income
                  items, omitted adjustments, or errors in the depreciation
                  schedule.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Is Schedule M-1 the same as Schedule M-3?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. Schedule M-1 is a concise 9-line reconciliation for small
                  to mid-sized partnerships.{' '}
                  <Link
                    href="https://www.irs.gov/forms-pubs/about-form-1065"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule M-3
                  </Link>{' '}
                  is a more detailed multi-page reconciliation required for
                  partnerships with $10 million or more in total assets.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What accounting basis should Line 1 reflect?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Line 1 should reflect the partnership's net income or loss as
                  recorded on its books, using whatever accounting method the
                  partnership uses (GAAP, cash basis, or other internal method).
                  It should not be adjusted to reflect tax rules.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. How does Schedule M-1 relate to Schedule K-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule M-1 reconciles the partnership's total book-to-tax
                  income difference. The tax income on Line 9 feeds into{' '}
                  <Link
                    href="/resources/business-tax/schedule-k/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule K
                  </Link>
                  , which then allocates each partner's share via{' '}
                  <Link
                    href="/resources/business-tax/schedule-k1-1065/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule K-1
                  </Link>
                  . Partners report their K-1 amounts — based on the tax income
                  figure — on their own returns.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  7. Can I e-file Form 1065 with Schedule M-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. Schedule M-1 is included as part of the electronic Form
                  1065 submission. TaxZerone supports complete{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    e-filing of Form 1065
                  </Link>{' '}
                  including all required schedules.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 0.5,

                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key IRS Resources for Schedule M-1
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Resource
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Description
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Link
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>Form 1065 (PDF)</TableCell>
                          <TableCell sx={{}}>
                            U.S. Return of Partnership Income
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download{' '}
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>
                            Instructions for Form 1065
                          </TableCell>
                          <TableCell sx={{}}>
                            IRS line-by-line instructions including Schedule M-1
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/instructions/i1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov{' '}
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Schedule M-3 (Form 1065)
                          </TableCell>
                          <TableCell sx={{}}>
                            Extended reconciliation for large partnerships
                          </TableCell>

                          <TableCell sx={{}}>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-1065"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              About Schedule M-3
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="related"
                >
                  Related TaxZerone Resources
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Resource
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/business-tax/efile-irs-form-1065-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              E-File Form 1065 Online
                            </Link>{' '}
                          </TableCell>

                          <TableCell>
                            Securely e-file your partnership return including
                            all schedules{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1065-instructions/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1065 Instructions
                            </Link>
                          </TableCell>

                          <TableCell>
                            Complete walkthrough of the Form 1065 return{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1065-filing-deadlines-and-penalties-guide/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1065 Filing Deadlines & Penalties
                            </Link>
                          </TableCell>

                          <TableCell>
                            Key filing dates and late-filing penalty details
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004 — Business Tax Extension
                            </Link>
                          </TableCell>

                          <TableCell>
                            Request a 6-month filing extension for Form 1065
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to e-file Form 1065 with accurate Schedule M-1
              reconciliation?
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure seamless book-to-tax compliance and avoid IRS audit flags.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href="/business-tax/efile-irs-form-1065-online/"
              >
                Start E-filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default SchM1Form1065;
